import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type NewMockupState = {
  name: string;
  collectionId: string;
  styleId: string;
  orgId: string;
  preview: string;
  correlationStyleId?: string;
  styleType?: '3D' | '2D';
};

const initialState: NewMockupState = {
  name: '',
  collectionId: '',
  styleId: '',
  orgId: '',
  preview: '',
  correlationStyleId: '',
  styleType: '3D',
};

export const newMockup = createSlice({
  name: 'newMockup',
  initialState,
  reducers: {
    setName: (state: NewMockupState, action: PayloadAction<string>) => {
      state.name = action.payload;
    },
    setCollectionId: (state: NewMockupState, action: PayloadAction<string>) => {
      state.collectionId = action.payload;
    },
    setStyleId: (state: NewMockupState, action: PayloadAction<string>) => {
      state.styleId = action.payload;
    },
    setOrgId: (state: NewMockupState, action: PayloadAction<string>) => {
      state.orgId = action.payload;
    },
    setPreivew: (state: NewMockupState, action: PayloadAction<string>) => {
      state.preview = action.payload;
    },
  },
});

export const { setName, setCollectionId, setStyleId, setPreivew, setOrgId } = newMockup.actions;

export const newMockupReducer = newMockup.reducer;
